<div
   [class.brick-container-hide-overflow]="disableBrickOverflow$ | async"
   [class.is-brick-being-edited]="isBrickBeingEdited$ | async"
   [style.width]="'100%'"
   [style.height]="'100%'"
   [style.font-size]="(brickScaling$ | async) + '%'"
   kendoTooltip
   [position]="dialogPosition$ | async"
   [collision]="{ horizontal: 'fit', vertical: 'fit' }"
   [tooltipTemplate]="settingsTooltipTemplate"
   tooltipClass="tooltip-popup"
   [isTooltipVisible]="isBrickSettingsDialogOpened$ | async"
>
   <samweb-loading-indicator
      fxFlexFill
      [showForAllLongRunningContextCategories]="true"
      [brickInstanceId]="this.brickInstanceId"
      [runForever]="false"
   >
      <!--  Here the Brick content is hosted!-->
      <ng-template componentHost></ng-template>
   </samweb-loading-indicator>
</div>

<div class="disable-edit-mode" *ngIf="isBrickOverlayVisible$ | async">
   <samweb-brick-control-overlay [brickInstanceId]="this.brickInstanceId" fxFill> </samweb-brick-control-overlay>
</div>

<ng-template #settingsTooltipTemplate>
   <div class="sam-margin">
      <samweb-brick-settings [brickInstanceId]="brickInstanceId"></samweb-brick-settings>
   </div>
</ng-template>
